<p class="maxx-brand__muted body-13-regular">
  The design MAXX uses for PDFs and decks. Changes apply to new files only.
</p>

@if (isLoading()) {
  <p class="maxx-brand__muted body-13-regular">Loading…</p>
} @else if (loadFailed()) {
  <p class="maxx-brand__error body-13-regular">Could not load the brand kit. Please try again.</p>
} @else {
  <div class="maxx-brand__row">
    <div class="maxx-brand__row-text">
      <span class="body-14-medium">Design</span>
      <span class="maxx-brand__muted body-12-regular">Use PDQ’s design or your own.</span>
    </div>
    <pdq-dropdown
      class="maxx-brand__control"
      [options]="designOptions()"
      [defaultOption]="selectedDesign()"
      [disabled]="isSaving()"
      (onChange)="selectDesign($event)"></pdq-dropdown>
  </div>

  @if (enabled()) {
    <div class="maxx-brand__row">
      <div class="maxx-brand__row-text">
        <span class="body-14-medium">Brand name</span>
        <span class="maxx-brand__muted body-12-regular">Shown on your files.</span>
        @if (needsBrandName()) {
          <span class="maxx-brand__error body-12-regular">Enter a brand name to use your own design.</span>
        }
      </div>
      <pdq-input
        class="maxx-brand__control"
        [control]="brandNameControl"
        [value]="brandName()"
        [disabled]="isSaving()"
        [maxLength]="128"></pdq-input>
    </div>

    <div class="maxx-brand__row">
      <div class="maxx-brand__row-text">
        <span class="body-14-medium">Logo</span>
        <span class="maxx-brand__muted body-12-regular">PNG, JPEG or WebP, up to 512 KB.</span>
        @if (needsLogo()) {
          <span class="maxx-brand__error body-12-regular">Upload a logo to use your own design.</span>
        }
      </div>
      <div class="maxx-brand__logo-actions">
        @if (logo().preview; as preview) {
          <img class="maxx-brand__logo" [src]="preview" alt="Logo" />
        }
        <pdq-link [label]="logo().preview ? 'Replace' : 'Upload'" (onClick)="logoInput.click()"></pdq-link>
        <input #logoInput type="file" hidden [accept]="logoAccept" (change)="pickLogo($event, 'logo')" />
      </div>
    </div>

    <div class="maxx-brand__row">
      <div class="maxx-brand__row-text">
        <span class="body-14-medium">Logo for dark backgrounds</span>
        <span class="maxx-brand__muted body-12-regular">Optional. Uses the logo above when empty.</span>
      </div>
      <div class="maxx-brand__logo-actions">
        @if (logoOnDark().preview; as preview) {
          <img class="maxx-brand__logo maxx-brand__logo--dark" [src]="preview" alt="Logo for dark backgrounds" />
          <pdq-link label="Remove" (onClick)="removeLogoOnDark()"></pdq-link>
        }
        <pdq-link [label]="logoOnDark().preview ? 'Replace' : 'Upload'" (onClick)="logoOnDarkInput.click()"></pdq-link>
        <input #logoOnDarkInput type="file" hidden [accept]="logoAccept" (change)="pickLogo($event, 'logoOnDark')" />
      </div>
    </div>

    @if (logoError()) {
      <p class="maxx-brand__error body-13-regular">{{ logoError() }}</p>
    }

    <div class="maxx-brand__row">
      <div class="maxx-brand__row-text">
        <span class="body-14-medium">Colors</span>
        <span class="maxx-brand__muted body-12-regular">Primary, ink</span>
      </div>
      <div class="maxx-brand__colors">
        <pdq-input-color
          [disabled]="isSaving()"
          [control]="primaryColorControl"
          [formControl]="primaryColorControl"
          placeholder="#884DFF"></pdq-input-color>
        <pdq-input-color
          [disabled]="isSaving()"
          [control]="inkColorControl"
          [formControl]="inkColorControl"
          placeholder="#241434"></pdq-input-color>
      </div>
    </div>
  }

  <div class="maxx-brand__preview">
    <span class="maxx-brand__muted body-12-regular">Preview</span>
    <div class="maxx-brand__preview-cards">
      @for (card of previewCards; track card.caption) {
        <div class="maxx-brand__preview-item">
          <div class="maxx-brand__card" [class.maxx-brand__card--slide]="card.slide">
            @if (previewLogo(); as logoSrc) {
              <img class="maxx-brand__card-logo" [src]="logoSrc" alt="" />
            } @else {
              <span class="maxx-brand__card-label" [style.color]="previewText()">{{ previewLabel() }}</span>
            }
            <span class="maxx-brand__card-title" [style.color]="previewText()">{{ card.title }}</span>
            <div class="maxx-brand__bars">
              @for (bar of card.bars; track $index) {
                <span
                  class="maxx-brand__bar"
                  [style.height.px]="bar.height"
                  [style.background]="bar.strong ? previewPrimary() : previewLight()"></span>
              }
            </div>
          </div>
          <span class="maxx-brand__muted body-12-regular">{{ card.caption }}</span>
        </div>
      }
    </div>
  </div>
}

<footer class="save-footer" [ngClass]="hasChanges() ? 'apear' : 'initial'">
  <span>You have unsaved changes</span>
  <pdq-button
    variant="secondary"
    label="cancel"
    class="action-btn"
    [disabled]="isSaving()"
    (onClick)="cancel()"></pdq-button>
  <pdq-button
    variant="primary"
    label="save"
    class="action-btn"
    [loading]="isSaving()"
    [disabled]="!canSave()"
    (onClick)="save()"></pdq-button>
</footer>
